import React ,{useState,useEffect} from 'react';
import {useHistory } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import PercentageBar from './component/work/percentageBar';
import HeaderTwo from './HeaderTwo'
import Slide  from './component/work/slide'
import Page  from './component/work/page'
import ReactFullpage from "@fullpage/react-fullpage";
import {ResGet,ResPost,url} from './component/resapi'
import imagesLoead from './component/utility/imageLoad'
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"
import Div100vh from 'react-div-100vh'
const pluginWrapper = () => {
  require("fullpage.js/vendors/scrolloverflow")
  // require("./component/fullpage.scrollOverflowReset.min")
}

// var smoothScroll = require('smoothscroll');
const Work =(props)=> {
  let history = useHistory();
  const [state, setstate] = useState(false)
  const [colorSlide , setColorSlide] =  useState("#fff")
  const [alldata,setAlldata] = useState({})
  const [alldataSection,setAlldataSection] = useState([])
  const [loading, setloading] = useState(true)
  const [index,setIndex] =useState(0) ;
  const [pageApi,setpageApi] =useState("") ;
  const [Percentag,setPercentag] =useState(0) ;
  useEffect(() => {
    props.isLoading(false)
    if(props.match.params.name!==undefined){
    ResGet(`get${props.match.params.pagename}/${props.match.params.name.split("-").join(" ")}`).then(async(response)=>{
        if(response.status===200){
          await setAlldata(
            {
              colorPalette:response.data.colorPalette,
              country:response.data.country,
              date:response.data.date,
              flag :response.data.flag,
              name : response.data.name,
              pictogram : response.data.pictogram,
              preview : response.data.preview,
              html : response.data.html,
            }
            )
            await ResPost(`getworkalso/${props.match.params.pagename}`,{data : response.data.filter,name:response.data.name}).then((response)=>{
              if(response.status===200){
                  setAlldata((value)=>Object.assign(value,{also:response.data} ))
              }
            })
            if(response.data.data.length>0){
              await setAlldataSection(response.data.data)
              imagesLoead((ev)=>{
                 setloading(false)
                 props.isLoading(true)
              })
              if(response.data.data[0].type==="page"){
                await setColorSlide("#000")
              }
              else await setColorSlide(response.data.data[0].image[0].color)
          }else history.push(`/${props.match.params.pagename}`)
        }else  history.push(`/${props.match.params.pagename}`)
    })
  } 
  else history.push(`/${props.match.params.pagename}`)
  },[history,pageApi])


  useEffect(()=>{
    if(window.innerWidth<1024){
      document.querySelector(".workpage").addEventListener("scroll",(ev)=>{
        const scrollDown = ev.target.scrollTop/(ev.target.scrollHeight-ev.target.clientHeight)
          setPercentag(scrollDown*100)
          return false
      },false)
    }else{
      let y =  0
      if(alldataSection){
        if(alldataSection.length===1){
          y = 100
        }
        else{
        const x = 100 / (alldataSection.length-1)
        y =  (x * index)
        }
      }
      setPercentag(y)
      
    }
    return () => {
      document.querySelector(".workpage").removeEventListener("scroll",null,false)
    };
  },[index,alldataSection])

  const fullpageOptions = {
    onLeave :async (index, nextIndex, direction)=>{
      pageApi.setAllowScrolling(false)
      if(alldataSection[nextIndex.index].type==="slide"){
        setColorSlide(alldataSection[nextIndex.index].image[0].color)
      }
      await setIndex(nextIndex.index)
      if(nextIndex.item.getAttribute("class").includes("container-main")) await setstate(true)
      else await setstate(false)
    },
    afterLoad: function(origin, destination, direction){
      if(pageApi){
        pageApi.setAllowScrolling(true)
      }
    },
    scrollOverflow: true,
    resize : true,
    css3:true,
    recordHistory: false,
    slidesNavPosition : "top",
    parallax : true,
    // autoScrolling:false,
    offsetSections:true,
    fitToSection: true,
    scrollOverflowReset: true,
	  fitToSectionDelay: 1000,
    scrollingSpeed :1200,
    loopTop : false,
    resetSliders : true,
    lazyLoading: true,
  }
  const handelShowAlso=(index)=>{
    if(alldataSection[alldataSection.length-1].type==="page"){
      if(alldataSection.length-1===parseInt(index) && alldataSection[index].type ==="page"){
        return alldata.also
      }
    }
    else {
      if(alldataSection.length-2===parseInt(index) && alldataSection[index].type ==="page"){
        return alldata.also
      }
      else {
        return [] 
      }
    }
  }
  return (
    <Div100vh className="workpage" style={{height:"100rvh",overflow:"hidden"}}>
     {/* <div style={{width:"100vw",height:"100vh",overflow:props.loadingRedux?"unset":"hidden"}}> */}
    <HeaderTwo w={state?true:colorSlide!=="#fff"?true:false}/>
    <PercentageBar percentage={Percentag}/> 
    <MetaTags>
            <meta name="description" content={alldata.html} />
            <meta property="og:title" content={alldata.name} />
            <meta property="og:image" content={url+"/"+alldata.preview} />
    </MetaTags>
    <div className="right-tabwork projectsection" style={{color:state?"#000":colorSlide}}>
      <div>
        {!loading && alldata.pictogram?
        alldata.pictogram.map((data,key)=>{
        if(data!==null && data.img!=="")
        return (
         <span key={key} className={`clickable ${alldataSection[index].name===data.name?"active":""}`} onClick={() => pageApi.moveTo(key+1,index)}>
            <span>{data.name}</span>
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10 10 ">
                <path style={{fill:state?"#000":colorSlide}} d={data.img}/>
            </svg>
          </span>
          )
          }):""}
      </div>
    </div>
    {!loading?
    <ReactFullpage
    {...fullpageOptions}
    pluginWrapper={pluginWrapper}
    licenseKey="774E4575-1D1444EF-A568F016-EF775089"
    scrollOverflowReset
    render={({ state, fullpageApi }) =>{
      if(state.initialized){
        if(window.innerWidth<1025){
          fullpageApi.destroy("all")
        }
        fullpageApi.reBuild()
        setpageApi(fullpageApi)
      }
      return(
        <ReactFullpage.Wrapper>
          {alldataSection.map((data,key)=>{
            if(data.type==="slide"){
             return <div className="section" key={key}><Slide route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} subData={{colorPalette:alldata.colorPalette,country:alldata.country,flag:alldata.flag}} data={data} index={key} setColor={setColorSlide}/></div>
            }
            else {
              return <div className="section container-main fp-auto-height" key={key} style={{backgroundColor:"#fff"}}><Page fullpageApi={pageApi} index={key} route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} recommend={handelShowAlso(key)} data={data}/></div>
            }
          })
        }
        </ReactFullpage.Wrapper>
      )
    }}
    />
    :
    alldataSection.map((data,key)=>{
      if(data.type==="slide"){
       return <div className="section" key={key}><Slide route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} subData={{colorPalette:alldata.colorPalette,country:alldata.country,flag:alldata.flag}} data={data} index={key} setColor={setColorSlide}/></div>
      }
      else {
        return <div className="section container-main" key={key} style={{backgroundColor:"#fff"}}><Page fullpageApi={pageApi} index={key} route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} recommend={handelShowAlso(key)} data={data}/></div>
      }
    })}
    {/* {alldataSection.map((data,key)=>{
      if(data.type==="slide"){
       return <div className="section" key={key}><Slide route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} subData={{colorPalette:alldata.colorPalette,country:alldata.country,flag:alldata.flag}} data={data} index={key} setColor={setColorSlide}/></div>
      }
      else {
        return <div className="section container-main" key={key} style={{backgroundColor:"#fff"}}><Page fullpageApi={pageApi} index={key} route={{params:props.match.params.name.split(" ").join("-"),pagename:props.match.params.pagename,name:alldata.name}} recommend={handelShowAlso(key)} data={data}/></div>
      }
    })} */}
    </Div100vh>
   
  );
}
const mapStateToProps = ({loading}) => {
  return {
      loadingRedux: loading.type,
  }
};

export default connect(mapStateToProps,{isLoading})(Work);